import React, { useEffect } from 'react'

import { Cookies, setCookie } from '@chegg-wt/core/utils/cookies'
import { Failure, Success } from './message'

export interface GatewayProps {
  /** should gateway succeed or fail */
  isValid: boolean
  /** how long will gateway activate */
  expiration: Date
  /** website name i.e. easybib or citationmachine */
  siteName: string
  /** website domain i.e. easybib.com or citationmachine.net */
  domainName: string
  /** name of the product i.e. EasyBib or CitationMachine */
  productName: string
  /** function to redirect, called after timer */
  redirect: () => void
  /** number of seconds to redirect after */
  afterSeconds: number
}

/** sets ad-related cookies, redirecting if the condition is invalid */
const Gateway: React.FunctionComponent<GatewayProps> = ({
  isValid,
  expiration,
  siteName,
  domainName,
  productName,
  redirect,
  afterSeconds,
}: GatewayProps) => {
  useEffect(() => {
    const domain = domainName ? `${domainName}` : ''

    // set a cookie to disable ads
    if (isValid) {
      setCookie(Cookies.Gateway, 'true', { domain, expires: expiration })
    }
    // set a cookie for ad layout user segmentation
    setCookie(Cookies.AdLayout, 'eb-gateway-e-test', { domain })
  }, [isValid, domainName, expiration])

  if (isValid) {
    return <Success siteName={siteName} domainName={domainName} />
  }
  return (
    <Failure
      redirect={redirect}
      afterSeconds={afterSeconds}
      siteName={siteName}
      domainName={domainName}
      productName={productName}
    />
  )
}

export default Gateway
